exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".trial{margin:50px auto}.trial .primary{font-family:poppins;color:#737373;font-size:32.4px;font-weight:600}.trial .primary:after{position:absolute;content:\"\";bottom:0;width:25%;left:37%;height:3px;background-color:#e6e6e6}.trial .sentence{padding:10px 0;font-size:2.5rem}.trial .btn{margin-left:10px;border-radius:200px}.trial .extra-sentence{padding-top:15px;width:80%;margin-left:auto;margin-right:auto;font-size:1.8rem}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/css/trialended.less
 ** module id = 783
 ** module chunks = 0
 **/